import backend from "../../../../backend/backend";
import GatewayActions from "./gatewayActions";
import Notify from "../../../shared/Notify";
import label from "../../../../i18n/label";

export const loadGateways = (intl, workspaceId) => {
  return (dispatch) => {
    backend
      .getGateways(workspaceId)
      .then((list) => {
        dispatch({ type: GatewayActions.LOADED_LIST, list });
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadGateway = (intl, workspaceId, gatewayUid) => {
  return (dispatch) => {
    backend
      .getGateway(workspaceId, gatewayUid)
      .then((gateway) => {
        dispatch({ type: GatewayActions.LOADED_GATEWAY, gateway });
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const createGateway = (intl, workspaceId, data, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .createGateway(workspaceId, data)
      .then((gateway) => {
        dispatch({ type: GatewayActions.CREATED_GATEWAY, gateway });
        Notify.success(label(intl, "gateway_created"));
        if (onSuccess) onSuccess(gateway);
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
        if (onError) onError();
      });
  };
};

export const updateGateway = (
  intl,
  workspaceId,
  gatewayUid,
  data,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .updateGateway(workspaceId, gatewayUid, data)
      .then((gateway) => {
        dispatch({ type: GatewayActions.UPDATED_GATEWAY, gateway });
        Notify.success(label(intl, "gateway_updated"));
        if (onSuccess) onSuccess(gateway);
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
        if (onError) onError();
      });
  };
};

export const deleteGateway = (intl, workspaceId, gatewayUid, onSuccess) => {
  return (dispatch) => {
    backend
      .deleteGateway(workspaceId, gatewayUid)
      .then(() => {
        dispatch({ type: GatewayActions.DELETED_GATEWAY, gatewayUid });
        Notify.success(label(intl, "gateway_deleted"));
        if (onSuccess) onSuccess();
      })
      .catch(() => {
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};
